export default {
  CHAIN_ID: 'secret-4',
  REST: process.env.REACT_APP_REST,
  RPC: process.env.REACT_APP_RPC,
  SEFI_CONTRACT_ADDRESS: 'secret15l9cqgz5uezgydrglaak5ahfac69kmx2qpd6xt',
  FACTORY_CONTRACT_ADDRESS: 'secret12hzxz4mw0yz8hnymhd7nrzzxlfqxxezgvemtnw'
};
